import dynamicComponentLoader from '../../shared/utils/dynamic-component-loader.js';
import eventHandlers from './event-handlers.js';
import euConsentLink from './utils/eu-consent-link.js';
import addNewTab from './utils/external-link.js';
import _ from '../../shared/utils/dont-need-lodash.js';

export default function bootstrap() {
  _.ready(() => {
    // Register global event handlers.
    eventHandlers();

    // Activate components.
    dynamicComponentLoader.load();
    [euConsentLink].map(util => util.load());
    addNewTab();
  });
}
bootstrap();
